import { render } from "./roles-permission.vue?vue&type=template&id=1c3f9164"
import script from "./roles-permission.vue?vue&type=script&lang=js"
export * from "./roles-permission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__